import { Alert, Snackbar } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { useState } from "react";
import useStyles from "./styles";
import ConfigReferenciaServico from "./configReferenciaServico";
import ConfigExibicaoCliente from "./configExibicaoCliente";
import ConfigIntegracaoErp from "./configIntegracaoErp";
import { temErp } from "../../../../../services/erpSistema";
import BuscaConfiguracao from "../buscaConfiguracao";

// Índice da busca (ver ../buscaConfiguracao). Ao criar uma configuração nova
// na tela, inclua-a aqui com o mesmo id.
const SECOES = [
  {
    secao: "referencia",
    titulo: "Referência do serviço / descrição auxiliar do contrato",
    visivel: () => temErp("HUBSOFT") || temErp("IXC"),
    termos: "hubsoft ixc regex",
    itens: [
      ["ref-cliente", "Mostrar a referência para os clientes", "portal regex"],
      [
        "ref-interno",
        "Mostrar a referência para os usuários internos",
        "regex",
      ],
    ],
  },
  {
    secao: "exibicao",
    titulo: "Configuração de exibição do nome do cliente",
    termos: "nome razao social fantasia",
    itens: [
      ["exibicao-padrao", "Padrão de exibição", "padrao global"],
      [
        "exibicao-cliente",
        "Configuração por cliente",
        "individual personalizado buscar cliente",
      ],
    ],
  },
  {
    secao: "integracao",
    titulo: "Configurações da integração ERP",
    visivel: () => temErp("HUBSOFT"),
    termos: "hubsoft sincronizacao",
    itens: [
      [
        "integracao-grupos",
        "Filtro de clientes por grupo de cliente",
        "grupos",
      ],
    ],
  },
];

export default function Clientes() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [snackbar, setSnackbar] = useState(null);

  return (
    <Box sx={{ p: 2 }}>
      <BuscaConfiguracao
        secoes={SECOES}
        placeholder="Buscar configuração (ex.: referência, nome, grupo)"
      />
      {/* Cada seção aparece se o sistema tem um ERP que a usa; nas por ERP,
          o ERP é escolhido dentro dela. Exibição do nome vale para todos. */}
      {(temErp("HUBSOFT") || temErp("IXC")) && <ConfigReferenciaServico />}
      <ConfigExibicaoCliente />
      {temErp("HUBSOFT") && <ConfigIntegracaoErp />}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
